import { organizationsApi } from "@facade/services";
import { queryOptions } from "@tanstack/react-query";

export const organizationsQueryKeys = {
  all: ["organizations"] as const,

  lists: () => [...organizationsQueryKeys.all, "list"] as const,
  list: () => [...organizationsQueryKeys.lists()] as const,

  details: () => [...organizationsQueryKeys.all, "detail"] as const,
  detail: (organizationId: string) =>
    [...organizationsQueryKeys.details(), organizationId] as const,

  publicDetail: (organizationId: string) =>
    [...organizationsQueryKeys.details(), "public", organizationId] as const,

  members: (organizationId: string) =>
    [...organizationsQueryKeys.detail(organizationId), "members"] as const,

  invitations: () => [...organizationsQueryKeys.all, "invitations"] as const,

  public: () => ["public"] as const,
};

export const organizationsQueries = {
  list: () =>
    queryOptions({
      queryKey: organizationsQueryKeys.list(),
      queryFn: organizationsApi.get,
    }),

  public: () =>
    queryOptions({
      queryKey: organizationsQueryKeys.public(),
      queryFn: organizationsApi.getPublic,
    }),

  detail: (organizationId: string) =>
    queryOptions({
      queryKey: organizationsQueryKeys.detail(organizationId),
      queryFn: () => organizationsApi.getById(organizationId),
      enabled: Boolean(organizationId),
    }),

  publicDetail: (organizationId: string) =>
    queryOptions({
      queryKey: organizationsQueryKeys.publicDetail(organizationId),
      queryFn: () => organizationsApi.getPublicById(organizationId),
      enabled: Boolean(organizationId),
    }),

  members: (organizationId: string) =>
    queryOptions({
      queryKey: organizationsQueryKeys.members(organizationId),
      queryFn: () => organizationsApi.getMembers(organizationId),
      enabled: Boolean(organizationId),
    }),

  invitations: () =>
    queryOptions({
      queryKey: organizationsQueryKeys.invitations(),
      queryFn: organizationsApi.getInvitations,
    }),
};
